export const copyRight = "© 2022 The Dorsey Group, All rights reserved.";